/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SanityInputs */

const en_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity`)
};

const ar_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity`)
};

const bn_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanity`)
};

const de_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vernunft`)
};

const es_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cordura`)
};

const fr_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé mentale`)
};

const pt_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanidade`)
};

const zh_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理智`)
};

const tr_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akıl Sağlığı`)
};

const ru_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здравомыслие`)
};

const pl_svchip_sanity = /** @type {(inputs: Svchip_SanityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poczytalność`)
};

/**
* | output |
* | --- |
* | "Sanity" |
*
* @param {Svchip_SanityInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_sanity = /** @type {((inputs?: Svchip_SanityInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SanityInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_sanity(inputs)
	if (locale === "bn") return bn_svchip_sanity(inputs)
	if (locale === "de") return de_svchip_sanity(inputs)
	if (locale === "es") return es_svchip_sanity(inputs)
	if (locale === "fr") return fr_svchip_sanity(inputs)
	if (locale === "pt") return pt_svchip_sanity(inputs)
	if (locale === "zh") return zh_svchip_sanity(inputs)
	if (locale === "tr") return tr_svchip_sanity(inputs)
	if (locale === "ru") return ru_svchip_sanity(inputs)
	if (locale === "pl") return pl_svchip_sanity(inputs)
	return en_svchip_sanity(inputs)
});